import React from 'react';
import {TextProps} from '@chakra-ui/react';
import {Col, UiText} from '~/components/elements';
import {Program} from '~/types/models/questionnaire';
import {WL_PROGRAMS} from '~/constants';

interface Props {
  program: Program;
  isSelected: boolean;
  onClick: (value: string) => void;
}

/**
 * Renders a program card component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.program - The program object.
 * @param {boolean} props.isSelected - Indicates if the program is selected.
 * @param {Function} props.onClick - The function to handle click events.
 * @param {Object} props.rest - The rest of the component props.
 * @returns {JSX.Element} The rendered ProgramCard component.
 */
const ProgramCard = ({program, isSelected, onClick}: Props): JSX.Element => {
  const isSmallTag =
    program.value === WL_PROGRAMS.ELEVATE_GLP_1_PROGRAM.value ||
    program.value === WL_PROGRAMS.ELEVATE_PILL_PROGRAM.value;

  return (
    <Col
      w="90%"
      borderRadius="1.6rem"
      mb={7}
      cursor={'pointer'}
      boxShadow={isSelected ? '0px 0px 0px 5px #CCDF75' : 'none'}
      onClick={() => onClick(program.value)}
    >
      <Col position="relative" justifyContent="center" alignItems="center">
        <img src={program.image} alt={program.label} style={{width: '100%', height: '8rem', maxWidth: 'none'}} />
        <Col w="100%" position="absolute" justifyContent="center" alignItems="center">
          {program.tags?.map((tag, index) => {
            return (
              <Col
                bg="lightBaseColor"
                key={index}
                px={4}
                py={2}
                borderRadius="100px"
                minW={isSmallTag ? '8rem' : '13rem'}
              >
                <UiText fontSize="sm" fontWeight="600">
                  {tag}
                </UiText>
              </Col>
            );
          })}
        </Col>
      </Col>
      <Col px={2} py={4} pt={2.5} borderBottomRadius="1.5rem" border="1.5px solid" borderTop="none">
        <UiText fontSize="xl" fontWeight="bold" color="#8DAA09" mb={2.5}>
          {program.label}
        </UiText>
        <UiText fontSize="sm">{program?.description}</UiText>
      </Col>
    </Col>
  );
};

export default ProgramCard;
